import { withAuthenticator } from '@aws-amplify/ui-react'
import React, { useEffect, useState } from 'react'
import { Modal } from 'reactstrap'
import { Table } from '../../components/table'
import { Header } from '../../components/header'
import { Sidebar } from '../../components/sidebar'
import { deleteData, getData } from '../../utils/server'
import { Footer } from '../../components/footer'
import AddImageModal from './flash-card-images-modal'

interface OriginalImage {
  Key: string
  LastModified: string
  Size: string
  StorageClass: string
}

function Images() {
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [modal_backdrop, setmodal_backdrop] = useState(false)
  const [modalImage, setModalImage] = useState<OriginalImage>()
  const [images, setImages] = useState<any[]>([])

  useEffect(() => {
    if (!success && !error) {
      getData('/images/flashcard').then(
        (result: any) => {
          setSuccess(true)
          setImages(result)
        },
        (error: any) => {
          setError(error)
        },
      )
    }
  })

  function tog_backdrop(item?: OriginalImage) {
    setModalImage(undefined)
    setmodal_backdrop(!modal_backdrop)
    removeBodyCss()

    if (item) {
      setModalImage(item)
    }
  }

  function put_image(image: OriginalImage) {
    if (images.some((x) => x.original === image.Key)) {
      const item = images.findIndex((x) => x.Key === image.Key)
      images[item] = image
    } else {
      setImages([...images, image])
    }
  }

  function removeBodyCss() {
    document.body.classList.add('no_padding')
  }

  function delete_item(key: string) {
    // eslint-disable-next-line no-restricted-globals
    if (
      confirm('Are you sure you want to delete this set of images?') === true
    ) {
      deleteData('/image/delete', key).then(
        (result: any) => {
          setImages(images.filter((image) => image.original !== key))
        },
        (error: any) => {
          setError(error)
        },
      )
    }
  }

  return (
    <div>
      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <h4 className="font-size-18">Flash Card Images</h4>
            <button
              type="button"
              className="btn btn-success float-end"
              onClick={() => {
                tog_backdrop()
              }}
              data-toggle="modal"
              style={{ marginRight: '50px' }}
            >
              Add New
            </button>
            <Modal
              size="lg"
              isOpen={modal_backdrop}
              toggle={() => {
                tog_backdrop()
              }}
              backdrop={'static'}
              id="staticBackdrop"
            >
              <AddImageModal
                setmodal_backdrop={setmodal_backdrop}
                put_image={put_image}
              />
            </Modal>
            <Table columns={['Preview', 'URL', 'Size', 'Storage Class']}>
              {images.map((item: OriginalImage, count: any) => (
                <tr key={count}>
                  <td>
                    <img
                      src={`${
                        process.env.REACT_APP_MEDIA_URL
                      }/${item.Key.replace('original', 'gallery')}`}
                    />
                  </td>
                  <td>
                    <a
                      href={`${process.env.REACT_APP_MEDIA_URL}/${item.Key}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.Key}
                    </a>
                  </td>
                  <td>{item.Size}</td>
                  <td>{item.StorageClass}</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-light btn-sm"
                      onClick={() => {
                        delete_item(item.Key)
                      }}
                      data-toggle="modal"
                    >
                      <i className="bx bx-x"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </Table>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}

export const FlashCardImages = withAuthenticator(Images, {
  hideSignUp: true,
  loginMechanisms: ['email'],
})
